import { useQuery } from '@tanstack/react-query';
import { getGrsAiSummariesPreference } from '../../core/coursePreferences.js';
import { useAiFeatureAccess } from './useAiFeatureAccess.js';

/**
 * Whether GRS AI summaries are active: course opt-in preference AND ml-authz
 * content_generation access. Wait on `isLoading` before rendering opt-in UI.
 *
 * @param {string} courseId
 * @param {boolean} [enabled=true]
 * @returns {{ aiSummariesPreferenceEnabled: boolean, isLoading: boolean }}
 */
export const useGrsAiSummariesPreference = (courseId, enabled = true) => {
  const { data: preferenceEnabled, isLoading: isPreferenceLoading } = useQuery({
    queryKey: ['coursePreference', 'grs_ai_summaries', courseId],
    queryFn: () => getGrsAiSummariesPreference(courseId),
    enabled: enabled,
  });

  const {
    aiFeatureAccess,
    isLoading: isFeatureAccessLoading,
  } = useAiFeatureAccess(courseId, enabled);
  const isContentGenerationAllowed =
    aiFeatureAccess.content_generation !== false;

  return {
    aiSummariesPreferenceEnabled:
      preferenceEnabled && isContentGenerationAllowed,
    isLoading: isPreferenceLoading || isFeatureAccessLoading,
  };
};
